import path from 'path';

export const ENV = process.env.NODE_ENV || 'development';
export const HOST = 'localhost';
export const PORT = 8080;
export const DIR_ROOT = path.resolve('./');
export const DIR_SRC = path.join(DIR_ROOT, '/src');
export const DIR_DIST = path.join(DIR_ROOT, '/dist');
export const DIR_NPM = path.join(DIR_ROOT, '/node_modules');
export const DIR_TEST = path.join(DIR_ROOT, '/test');
export const DIR_TESTDIST = path.join(DIR_ROOT, '/.tmp');
export const TEST_PORT = 8081;
export const DIR_STYLEGUIDE = path.join(DIR_ROOT, '/static');
export const STYLEGUIDE_PORT = 8082;
export const CDN_PATH = 'https://assets.naturaltherapypages.com.au/';
export const LOCAL_ASSETS_PATH = 'http://lifeboat.assets/';
export const API_PATH = '/api/suggest/';

export default {
  ENV,
  HOST,
  PORT,
  DIR_ROOT,
  DIR_SRC,
  DIR_DIST,
  DIR_NPM,
  DIR_TEST,
  DIR_TESTDIST,
  TEST_PORT,
  DIR_STYLEGUIDE,
  STYLEGUIDE_PORT,
  CDN_PATH,
  LOCAL_ASSETS_PATH,
  API_PATH
};



// WEBPACK FOOTER //
// ../webpack/_config.js